var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_160_3413",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_160_3413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 20.0001V16.6667H18.3346V20.0001H1.66797ZM5.0013 13.3334H6.16797L12.668 6.85425L11.4805 5.66675L5.0013 12.1667V13.3334ZM3.33464 15.0001V11.4584L12.668 2.14591C12.8207 1.99314 12.9978 1.87508 13.1992 1.79175C13.4006 1.70841 13.6124 1.66675 13.8346 1.66675C14.0569 1.66675 14.2721 1.70841 14.4805 1.79175C14.6888 1.87508 14.8763 2.00008 15.043 2.16675L16.1888 3.33341C16.3555 3.48619 16.477 3.66675 16.5534 3.87508C16.6298 4.08341 16.668 4.29869 16.668 4.52091C16.668 4.72925 16.6298 4.93411 16.5534 5.1355C16.477 5.33689 16.3555 5.52092 16.1888 5.68758L6.8763 15.0001H3.33464Z",
    fill: "#198FD9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d2a985cfd4bf2e9073053ff5dfa65d63.svg";
export { ForwardRef as ReactComponent };